export const api = {
  endpoint: import.meta.env.VITE_BACKEND_URL ?? "https://bloodline-api.eidra.com",
};

export const isFeatureEnabled = (value: string | undefined): boolean => value === "true";

export const featureFlags = {
  scbWorkplacesReadEnabled: isFeatureEnabled(import.meta.env.VITE_SCB_WORKPLACES_READ_ENABLED),
} as const;

export const VARIABLES = {
  // Can update the version to other value in here if you want to reset storage
  LANDING_PAGE_COLUMN_STORAGE: "NewLandingPageColumnStorage-version-3",
  LANDING_PAGE_FILTERING: "LandingPageFiltering",
  isDesktopPixels: "960px",
};
